import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "main-header--menu"
}
const _hoisted_4 = { class: "caption-navbar color-text-primary" }
const _hoisted_5 = { class: "main-header--menu-open color-grey-light" }
const _hoisted_6 = {
  key: 0,
  class: "main-header--menu-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "main-header--menu-list-mobile" }
const _hoisted_9 = { class: "main-header__modal" }
const _hoisted_10 = { class: "main-header__modal-header h1 color-secondary" }
const _hoisted_11 = ["onClick"]

import BaseButton from "@/components/base/BaseButton.vue";
import AsideModal from "@/components/aside/AsideModal.vue";
import NavBar from "@/components/aside/NavBar.vue";
import { useAsideMenu } from "@/composables/aside/useAsideMenu";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AsideMenu',
  setup(__props) {

const {
  changeMenu,
  clearData,
  currentUserPhone,
  formatPhoneNumber,
  isAsideHidden,
  isAuth,
  isLoadingSelectPhone,
  isLogoHidden,
  isShowList,
  menuList,
  phones,
  configDataBrand,
  setCurrentPhone,
  t,
  isSelectPoint,
} = useAsideMenu();

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass([{ hide: _unref(isLogoHidden) }, "main-header"])
  }, [
    _createElementVNode("img", {
      src: _unref(configDataBrand).assets.logo,
      class: "main-header__logo",
      alt: "Логотип"
    }, null, 8, _hoisted_1),
    _createElementVNode("img", {
      class: "main-header__logo_mobile",
      src: _unref(configDataBrand).assets.mobileLogo,
      alt: "Логотип"
    }, null, 8, _hoisted_2),
    (_unref(isAuth))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["main-header--menu-user", { 'hide-item': _unref(isLogoHidden) }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowList.value = !_unref(isShowList)))
          }, [
            _createVNode(BaseFigureForIcon, {
              icon: "account",
              color: "secondary",
              size: "small",
              type: "icon"
            }),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(currentUserPhone) ? _unref(formatPhoneNumber)(_unref(currentUserPhone)) : ""), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(BaseIcon, {
                name: "service-arrow",
                position: _unref(isShowList) ? 'top' : 'bottom'
              }, null, 8, ["position"])
            ])
          ], 2),
          (_unref(isShowList))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phones), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.phone_number,
                    class: _normalizeClass(["main-header--menu-phone-item", { disabled: _unref(isLoadingSelectPhone) }]),
                    onClick: ($event: any) => (_unref(setCurrentPhone)(item.phone_number))
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
              'main-header--menu-phone',
              'caption-navbar',
              { 'color-secondary': item.phone_number === _unref(currentUserPhone) },
            ])
                    }, _toDisplayString(_unref(formatPhoneNumber)(item.phone_number)), 3)
                  ], 10, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AsideModal, {
              "is-show": _unref(isShowList),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (isShowList.value = false)),
              "is-white": true,
              "full-height": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("aside.selectNumber")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phones), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.phone_number,
                      class: _normalizeClass([
                'main-header--menu-phone-item',
                {
                  'secondary-background':
                    item.phone_number === _unref(currentUserPhone),
                  disabled: _unref(isLoadingSelectPhone),
                },
              ]),
                      onClick: ($event: any) => (_unref(setCurrentPhone)(item.phone_number))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass([
                  'main-header--menu-phone',
                  'color-text-primary',
                  'caption-navbar',
                  { currentPhone: item.phone_number === _unref(currentUserPhone) },
                ])
                      }, _toDisplayString(_unref(formatPhoneNumber)(item.phone_number)), 3),
                      _createVNode(BaseFigureForIcon, {
                        icon: 
                  _unref(isSelectPoint)(item.phone_number) ? 'check-sharp' : 'more'
                ,
                        size: "small",
                        color: 
                  _unref(isSelectPoint)(item.phone_number)
                    ? 'white-opacity-15'
                    : 'secondary'
                
                      }, null, 8, ["icon", "color"])
                    ], 10, _hoisted_11))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["is-show"])
          ]),
          _createVNode(NavBar, {
            "menu-items": _unref(menuList),
            onChangeMenu: _unref(changeMenu)
          }, null, 8, ["menu-items", "onChangeMenu"]),
          _createVNode(BaseButton, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(clearData)())),
            title: _unref(t)('aside.logout'),
            size: "large",
            color: "transparent-primary",
            class: "main-header--menu-btn"
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, !_unref(isAsideHidden)]
  ])
}
}

})